<div class="dialog-header">
  <h2>Run Amount</h2>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content class="mat-typography">
  <table>
    <thead>
      <tr>
        <th>Run</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      @for (each of runPnLs; track each) {
        @if (each.runs >= 0) {
          <tr>
            <td>{{ each.runs }}</td>
            <td>
              <b
                [ngClass]="{
                  'pnl-green': each.pnl > 0,
                  'pnl-red': each.pnl < 0,
                }"
                >{{ each.pnl | number: "1.0-2" }}</b
              >
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</mat-dialog-content>
